module.exports = __webpack_public_path__ + "img/success.a77c5074.svg";